import { trackRouter, useGtag } from "vue-gtag-next";
import { createRouter, createWebHashHistory, RouteRecordRaw } from "vue-router";
import { useStore } from "vuex";
import { _$t } from "@/utils/i18n";
import HealthCare from "@/views/pages/HealthCare/index.vue";
import Survey from "@/views/pages/HealthCare/Survey.vue";
import SurveyForm from "@/views/pages/HealthCare/SurveyForm.vue";
import SurveyFormConfirm from "@/views/pages/HealthCare/SurveyFormConfirm.vue";
import SurveyFormComplete from "@/views/pages/HealthCare/SurveyFormComplete.vue";
import PageExpired from "@/views/pages/HealthCare/SurveyExpired.vue";
import Notifications from "@/views/pages/notice/NoticeList.vue";
import Password from "@/views/pages/profile/Password.vue";
import ArticleSearch from "@/views/pages/Content/Article/search.vue";
import Home from "@/views/pages/Home/index.vue";
import Article from "@/views/pages/Content/Article/index.vue";
import ContentDetail from "@/views/pages/Content/detail.vue";
import Profile from "@/views/pages/profile/Profile.vue";
import ProfileEdit from "@/views/pages/profile/ProfileEdit.vue";
import Welfare from "@/views/pages/Welfare/index.vue";
import Community from "@/views/pages/Community/index.vue";
import MyRecord from "@/views/pages/MyRecord/index.vue";
import HospitalVisit from "@/views/pages/MyRecord/HospitalVisit/index.vue";
import Treatment from "@/views/pages/MyRecord/Treatment/index.vue";
import DiagnosisProcess from "@/views/pages/MyRecord/DiagnosisProcess/index.vue";
import ClinicNote from "@/views/pages/MyRecord/HospitalVisit/ClinicNote/index.vue";
import MyReport from "@/views/pages/MyReport/index.vue";
import MyDailyNote from "@/views/pages/MyReport/MyDailyNote.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/home",
    name: "home",
    alias: "/",
    component: Home,
    props: true,
    meta: { title: _$t("home_title") },
  },
  {
    path: "/article",
    name: "article",
    component: Article,
    props: true,
    meta: {
      title: _$t("article_title"),
      noGa: true,
    },
  },
  {
    path: "/notice/detail/:articleId",
    name: "notice/detail",
    component: ContentDetail,
  },
  {
    path: "/article/detail/:articleId",
    name: "article/detail",
    component: ContentDetail,
  },
  {
    path: "/article/search",
    name: "article/search",
    component: ArticleSearch,
    meta: {
      title: _$t("article_title"),
      noGa: true,
    },
  },
  {
    path: "/survey/expired",
    name: "survey/expired",
    component: PageExpired,
    meta: {
      title: _$t("expired_title"),
      noGa: true,
    },
  },
  {
    path: "/health-care",
    name: "health-care",
    component: HealthCare,
    meta: { title: _$t("healthcare_title") },
  },
  {
    path: "/health-care/survey/:diseaseCode",
    name: "health-care/survey",
    component: Survey,
    meta: { title: _$t("healthcare_title") },
  },
  {
    path: "/health-care/survey/form/:surveyCode",
    name: "health-care/survey/form",
    component: SurveyForm,
    props: true,
    meta: { survey: "1", title: _$t("healthcare_title") },
  },
  {
    path: "/survey/form/:surveyCode",
    name: "survey/form",
    component: SurveyForm,
    props: true,
    meta: { survey: "1", title: _$t("healthcare_title") },
  },
  {
    path: "/health-care/survey/confirm/:surveyCode",
    name: "health-care/survey/confirm",
    component: SurveyFormConfirm,
    props: true,
    meta: {
      noGa: true,
    },
  },
  {
    path: "/health-care/survey/complete",
    name: "survey/compalete",
    component: SurveyFormComplete,
    props: true,
    meta: { title: _$t("survey_complete_title") },
  },
  // {
  //   path: "/community",
  //   name: "Community",
  //   component: Community,
  //   props: true,
  //   meta: { title: _$t("community_title") },
  // },
  {
    path: "/welfare",
    name: "welfare",
    component: Welfare,
    meta: {
      title: _$t("welfare_title"),
      noGa: true,
    },
  },
  {
    path: "/notifications",
    name: "notifications",
    component: Notifications,
    meta: { title: _$t("notice_title") },
  },
  {
    path: "/profile",
    name: "Profile",
    component: Profile,
    props: true,
    meta: {
      title: _$t("profile_title"),
      noGa: true,
    },
  },
  {
    path: "/profile/password",
    name: "Password",
    component: Password,
    props: true,
    meta: { title: _$t("password_change_title") },
  },
  {
    path: "/profile/edit",
    name: "ProfileEdit",
    component: ProfileEdit,
    props: true,
    meta: {
      title: _$t("profile_edit_title"),
      noGa: true,
    },
  },
  {
    path: "/my-record",
    name: "MyRecord",
    component: MyRecord,
    meta: { title: _$t("myRecord_title") },
  },
  {
    path: "/my-record/hospital-visit",
    name: "HospitalVisit",
    component: HospitalVisit,
    meta: { title: _$t("hospitalVisit_title") },
  },
  {
    path: "/my-record/hospital-visit/clinic-note/:hospitalVisitId",
    name: "ClinicNote",
    component: ClinicNote,
    meta: { title: _$t("clinic_note_title") },
    props: true,
  },
  {
    path: "/my-record/treatment",
    name: "Treatment",
    component: Treatment,
    meta: { title: _$t("treatment_title") },
  },
  {
    path: "/my-record/diagnosis-process",
    name: "DiagnosisProcess",
    component: DiagnosisProcess,
    meta: { title: _$t("diagnosisProcess_title") },
  },
  {
    path: "/my-report/:activeTab?",
    name: "MyReport",
    component: MyReport,
    meta: { title: _$t("myReport_title") },
    props: true,
  },
  {
    path: "/my-report/daily-note/:yearMonth?",
    name: "MyReportDailyNote",
    component: MyDailyNote,
    meta: { title: _$t("myReportDailyNote_title") },
    props: true,
  },
];
const router = createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior() {
    return { top: 0 };
  },
});
trackRouter(router); // Google Analyticsとの連携設定

router.beforeEach(async (to, _from, next) => {
  const store = useStore();
  await store.dispatch("fetchUser");
  if (!store.getters.getUser) {
    // 未ログイン
    let dest = "/cms/login";
    const record = to.matched.find((record) => record.meta.survey);
    if (record?.meta?.survey && to.params?.surveyCode !== "") {
      // ページ指定あり かつ アンケートフォームへのアクセス
      dest = `${dest}?route=${record.meta.survey}&page=${to.params.surveyCode}`;
    }
    location.href = dest;
  } else {
    document.title = (to.meta.title as string) || _$t("loading_title");
    next();
  }
});

router.afterEach((to: any) => {
  const { event, disable } = useGtag();

  // Google Analytics
  if (to.meta?.noGa) {
    disable(true); // 集計対象外
  } else {
    disable(false); // 集計対象

    // 詳細画面はarticleの扱い
    if (to.name === "article/detail") {
      event("page_view", {
        page_title: "article",
        page_path: "/article",
      });
    }
  }
});

export default router;
